module.exports = __webpack_public_path__ + "img/bg_mnjy_die@2x.0dcc153c.png";